import {
  ExpandMoreRoundedIcon,
  Flex,
  IconButton,
  MoreMenuIconButton,
  Rotate,
  styled,
  TableCell,
  TableRow,
  type TableRowProps,
  DeleteOutlineIcon,
} from '@shared/components';

import { type QBankStructureSettingSectionTableData } from '../qbank-structure-table';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderColor: theme.palette.grey[300],
  borderRight: `1px solid ${theme.palette.grey[300]}`,
  ...theme.typography.body2Semibold,
}));

interface SubjectTableRowProps extends TableRowProps {
  data: QBankStructureSettingSectionTableData;
  expanded?: boolean;
  onExpand?: (id: string) => void;
  childrenQuestionCount: number;
  handleDeleteMenu: (id: string) => void;
}

export default function SubjectTableRow(props: Readonly<SubjectTableRowProps>) {
  const {
    data,
    expanded: isExpanded = false,
    onExpand,
    childrenQuestionCount,
    handleDeleteMenu,
    ...restProps
  } = props;
  const { id } = data;

  return (
    <TableRow
      {...restProps}
      sx={{
        border: 'none',
        ':last-child': {
          borderRight: 'none',
          td: {
            borderBottom: 'none',
          },
        },
        backgroundColor: isExpanded ? (theme) => theme.palette.primary.light : undefined,
        ...restProps.sx,
      }}
    >
      <StyledTableCell
        sx={{
          p: (theme) => theme.spacing(0),
        }}
      >
        <Flex sx={{ alignItems: 'center' }}>
          <Flex sx={{ minWidth: '48px', alignItems: 'center', justifyContent: 'center' }}>
            <IconButton onClick={() => onExpand?.(id)}>
              <Rotate in={isExpanded}>
                <ExpandMoreRoundedIcon />
              </Rotate>
            </IconButton>
          </Flex>
          <Flex
            sx={(theme) => ({
              flex: 1,
              p: theme.spacing(2, 1),
            })}
          >
            {data.levelName}
          </Flex>
        </Flex>
      </StyledTableCell>
      <StyledTableCell align='center'>-</StyledTableCell>
      <StyledTableCell align='center'>{childrenQuestionCount}</StyledTableCell>
      <StyledTableCell
        align='center'
        sx={{
          borderRight: 'none',
        }}
      >
        <MoreMenuIconButton
          options={[
            {
              label: 'Remove',
              icon: <DeleteOutlineIcon sx={(theme) => ({ color: theme.palette.error.main })} />,
              sx: (theme) => ({ color: theme.palette.error.main }),
              onClick: () => handleDeleteMenu(id),
            },
          ]}
        />
      </StyledTableCell>
    </TableRow>
  );
}
